module.exports = __webpack_public_path__ + "img/services-types.d31ba495.svg";